/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestion_PatrolInputs */

const en_chat_suggestion_patrol = /** @type {(inputs: Chat_Suggestion_PatrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch a few test patrols`)
};

const fr_chat_suggestion_patrol = /** @type {(inputs: Chat_Suggestion_PatrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lance plusieurs patrouilles de test`)
};

const ms_sg2_chat_suggestion_patrol = /** @type {(inputs: Chat_Suggestion_PatrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancar beberapa rondaan ujian`)
};

/**
* | output |
* | --- |
* | "Launch a few test patrols" |
*
* @param {Chat_Suggestion_PatrolInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_suggestion_patrol = /** @type {((inputs?: Chat_Suggestion_PatrolInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestion_PatrolInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_suggestion_patrol(inputs)
	if (locale === "fr") return fr_chat_suggestion_patrol(inputs)
	return ms_sg2_chat_suggestion_patrol(inputs)
});